@if (collapsible()) {
  <div
    class="sorts-bar sorts-bar--collapsible"
    [ngClass]="containerClasses() || ''">
    <div class="sorts-bar__collapsible-top">
      <div class="sorts-bar__switches sorts-bar__switches--collapsible">
        @if (searchTerm()) {
          <p class="sorts-bar__results-count sorts-bar__results-count--search">
            {{ resultsCount() }} {{ 'global.resultFor' | translate }}
            <span class="text-primary-dark">"{{ searchTerm() }}"</span>
          </p>
        }
      </div>

      <button
        type="button"
        class="sorts-bar__toggle-btn"
        (click)="toggleSortMenu()"
        [attr.aria-expanded]="isShowingSortMenu">
        <span class="sorts-bar__toggle-text">
          {{ 'sorting.sort' | translate }}
        </span>
        <i
          class="iconsax sorts-bar__toggle-icon"
          [attr.icon-name]="
            isShowingSortMenu ? 'chevron-up' : 'chevron-down'
          "></i>
      </button>
    </div>

    @if (isShowingSortMenu) {
      <ul class="sorts-bar__sort-menu">
        @for (sort of sorts(); track sort) {
          <li
            class="sort-item sort-item--menu"
            [ngClass]="{
              'sort-item--active': activeTab === sort?.toUpperCase(),
            }"
            (click)="selectTab(sort)">
            {{ translateKey() ? (translateKey() + sort | translate) : sort }}
          </li>
        }
      </ul>
    }
  </div>
} @else {
  <div
    class="sorts-bar-row"
    [class.sorts-bar-row--segmented]="variant() === 'segmented'">
    <div
      class="sorts-bar"
      [class.sorts-bar--segmented]="variant() === 'segmented'"
      [ngClass]="containerClasses() || ''">
      @if (variant() === 'segmented') {
        <div class="sorts-bar__segmented-inner">
          <ul
            class="sorts-bar__segmented-tabs"
            [class.sorts-bar__segmented-tabs--many]="sorts().length > 2">
            @for (sort of sorts(); track sort) {
              <li
                class="sort-item sort-item--segmented"
                [ngClass]="{
                  'sort-item--segmented-active':
                    activeTab === sort?.toUpperCase(),
                }"
                (click)="selectTab(sort)">
                {{
                  translateKey() ? (translateKey() + sort | translate) : sort
                }}
              </li>
            }
          </ul>

          <div class="sorts-bar__segmented-meta">
          @if (resultsCount() !== undefined && resultsCount() !== null) {
            <p
              class="sorts-bar__results-count sorts-bar__results-count--segmented">
              <span class="sorts-bar__results-count-value">{{
                resultsCount()
              }}</span>
              {{ 'global.results' | translate }}
            </p>
          }

          @if (showFiltersButton()) {
            <button
              type="button"
              class="sorts-bar__filters-btn sorts-bar__filters-btn--segmented"
              (click)="onFiltersButtonClick()"
              [attr.aria-label]="'solutions.filters.toggle' | translate">
              <i
                class="iconsax sorts-bar__filters-icon"
                icon-name="filter-search"></i>
            </button>
          }
          </div>
        </div>
      } @else {
        <!-- sorts tab -->
        <ul class="sorts-bar__tab-sort">
          @for (sort of sorts(); track sort) {
            <li
              class="sort-item"
              [ngClass]="{
                'sort-item--active': activeTab === sort?.toUpperCase(),
              }"
              (click)="selectTab(sort)">
              {{ translateKey() ? (translateKey() + sort | translate) : sort }}
            </li>
          }
        </ul>

        <div class="sorts-bar__switches">
          @if (verifyCompanyBtn() || verifyStoneBtn()) {
            @if (verifyCompanyBtn()) {
              <pwj-toggle-switch
                label="sorting.verifyCompany"
                labelClasses="!text-text-dark"
                labelIcon="blue-verify"
                [isChecked]="isVerifiedCompany"
                (onToggle)="onToggleSort($event, 'business_verified')">
              </pwj-toggle-switch>
            }
            @if (verifyStoneBtn()) {
              <pwj-toggle-switch
                label="sorting.verifyStone"
                labelClasses="!text-text-dark"
                labelIcon="golden-verify"
                [isChecked]="isVerifiedStone"
                (onToggle)="onToggleSort($event, 'specialist_verified')">
              </pwj-toggle-switch>
            }
          }

          @if (resultsCount()) {
            <p class="sorts-bar__results-count">
              {{ resultsCount() }} {{ 'global.resultCount' | translate }}
            </p>
          }
        </div>
      }
    </div>

    @if (showFiltersButton() && variant() !== 'segmented') {
      <button
        type="button"
        class="sorts-bar__filters-btn"
        (click)="onFiltersButtonClick()"
        [attr.aria-label]="'solutions.filters.toggle' | translate">
        <i class="iconsax sorts-bar__filters-icon" icon-name="filter-search"></i>
      </button>
    }
  </div>
}
